const emailConfig = {
  SERVICE_ID: `pk_builders`,
  TEMPLATE_ID: `pk_builders`,
  USER_ID: `user_ikUrtuLQS1ZglMV1GGmic`,
};

export default emailConfig;
